import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReusableForm from '../../components/ReusableForm';
import '../styles/FormPageStyles.css';
import { validarCodigo } from '../../services/Auth/forgotPasswordServer';

const ValidateCodePage = () => {
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');

    if (!email || !code) {
      setError('Por favor, introduce tu email y el código de verificación.');
      return;
    }

    try {
      const result = await validarCodigo({ email, codigo: code });
      if (result && result.tokenTemporal) {
        localStorage.setItem('token_temporal', result.tokenTemporal);
        setSuccessMessage('Código validado correctamente. Redirigiendo para cambiar contraseña...');
        setTimeout(() => {
          navigate('/auth/reset-password');
        }, 2000);
      } else {
        setError(result.message || 'Error al validar el código. Asegúrate de que el email y el código son correctos.');
      }
    } catch (err) {
      console.error("Error al validar código:", err);
      setError('Ocurrió un error al intentar validar el código. Por favor, inténtalo de nuevo.');
    }
  };

  return (
    <ReusableForm
      title="Validar Código"
      error={error}
      successMessage={successMessage}
      handleSubmit={handleSubmit}
      submitButtonText="Validar Código"
      afterButtonContent={
        <p className="form-link-text">
          ¿No recibiste el código? <Link to="/auth/forgot-password">Reenviar código</Link>
        </p>
      }
    >
      <div className="form-group">
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="form-input"
          placeholder="Ingresa tu correo electrónico."
        />
      </div>
      <div className="form-group">
        <input
          type="text"
          id="code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          required
          className="form-input"
          placeholder="Ingresa el código de verificación."
        />
      </div>
    </ReusableForm>
  );
};

export default ValidateCodePage; 